import React from "react";
import Container from "react-bootstrap/Container";

const Footer = (props) => {

  const {isDarkMode} = props

  return (
    <footer className={`${isDarkMode? "dark-theme-footer color-theme-light" : "light-theme-footer"} mt-auto py-5 text-center`}>
      <Container>
        {props.children}
      </Container>
    </footer>
  );
};

export default Footer;
